module.exports = __webpack_public_path__ + "static/media/bot_users.b70559c7.svg";